export const MODULE_PATHS = Object.freeze({
  workspaceHome: "home",
  financeManager: "finance-manager",
  homeManager: "home-manager",
  goalManager: "goal-manager",
  config: "configuration",
});

export const LEGACY_MODULE_PATHS = Object.freeze({
  financeManager: "fm",
  homeManager: "hm",
  goalManager: "gm",
});

export const LAYOUT_IDENTIFIERS = Object.freeze({
  workspaceHome: MODULE_PATHS.workspaceHome,
  financeManager: MODULE_PATHS.financeManager,
  homeManager: MODULE_PATHS.homeManager,
  goalManager: MODULE_PATHS.goalManager,
  config: "CONFIG",
});

export const MODULE_LABELS = Object.freeze({
  [LAYOUT_IDENTIFIERS.workspaceHome]: "Home",
  [LAYOUT_IDENTIFIERS.financeManager]: "Money",
  [LAYOUT_IDENTIFIERS.homeManager]: "Household",
  [LAYOUT_IDENTIFIERS.goalManager]: "Goals",
  [LAYOUT_IDENTIFIERS.config]: "Configuration",
});
